export enum ELinkType {
  package = 'package_link',
  collaboration = 'collaboration_link',
}
